// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductSupport_container__EapUY","productSupport":"ProductSupport_productSupport__LGQRA","productSupport__headline":"ProductSupport_productSupport__headline__QNfmx"};